import { render, staticRenderFns } from "./PushNotificationRequest.vue?vue&type=template&id=07e2d584&scoped=true"
import script from "./PushNotificationRequest.vue?vue&type=script&lang=js"
export * from "./PushNotificationRequest.vue?vue&type=script&lang=js"
import style0 from "./PushNotificationRequest.vue?vue&type=style&index=0&id=07e2d584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e2d584",
  null
  
)

export default component.exports